interface TChatUrlParams {
    leadId?: string | null;
    storeId?: string | null;
}

/**
 * Endpoint of the chat history: the lead chat when there is a lead, otherwise
 * the general chat of the store.
 */
export const getChatUrl = ({ leadId, storeId }: TChatUrlParams): string =>
    leadId
        ? `/ai/leads/${leadId}/chat`
        : `/ai/chat?storeId=${encodeURIComponent(storeId || '')}`;
